import { BaseModel } from './BaseModel';

export interface ICertificateModelProps {
    id?: string;
    userName: string;
    certificateLink: string;
    certificateName: string;
    moduleName: string;
    dateCreated: string;
    category: string;
}


export class CertificateModel extends BaseModel<ICertificateModelProps> {
    constructor(props: ICertificateModelProps) {
        super(props);
    }

    public static get(id: string) {
        return CertificateModel.getSingleInstance<ICertificateModelProps>(id);
    }

    public static list() {
        return CertificateModel.listAll<ICertificateModelProps>();
    }
    public static resource: string = 'certificate';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/CertificateModel.ts